// extracted by mini-css-extract-plugin
export default {"link":"rA-z","disabled":"sA-z"};